import React from "react";
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Tooltip,
  Text,
  Cell,
  Label
} from "recharts";
import { UNMET_DEMAND_COLOR } from "../../../api/Teams";

function renderLabel(props) {
  const percent = (props.percent * 100).toFixed(0);

  return (
    <Text
      {...props}
      alignmentBaseline="middle"
      className="recharts-pie-label-text"
    >
      {`${percent}%`}
    </Text>
  );
}

function formatMillions(val) {
  let valStr = (val / 1000000).toFixed(2);
  return `${valStr}M`;
}

function MarketCaptureChart({ data, colors, totalDemand }) {
  let unmetDemand = totalDemand;
  const result = data.map(item => {
    const { name, value } = item;
    unmetDemand -= value;

    return {
      name,
      value
    };
  });

  result.push({
    name: "Unmet Demand",
    value: unmetDemand
  });

  const teams_count = result.length - 1;

  return (
    <div className="donut-chart donut-chart-us">
      <ResponsiveContainer width="100%" height={235}>
        <PieChart>
          <Pie
            data={result}
            dataKey="value"
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={80}
            fill="#8884d8"
            label={renderLabel}
            labelLine={true}
          >
            <Label
              position="center"
              value={`Total Demand: ${formatMillions(totalDemand)}`}
            />
            {colors.slice(0, teams_count).map((color, i) => (
              <Cell key={i} fill={color} />
            ))}
            <Cell fill={UNMET_DEMAND_COLOR} />
          </Pie>
          <Tooltip formatter={formatMillions} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}

export default MarketCaptureChart;



// WEBPACK FOOTER //
// ./src/instructor/components/charts/market-capture-chart.js